import {
  Button,
  Divider,
  Drawer,
  message,
  DatePicker,
  Form,
  Tag,
  Modal,
} from "antd";
import { useEffect, useState } from "react";
import {
  EditOutlined,
  FilePdfOutlined,
  ReloadOutlined,
  FilterOutlined,
  OrderedListOutlined,
  FileOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import print from "print-js";
import CustomTable from "../ui/CustomTable";
import { Link, useParams } from "react-router-dom";
import {
  downloadFromData,
  downloadPDF,
  getInvoiceToBlobUrl,
  showPdfInModal,
  getTicketToBlobUrl,
} from "../../Helpers/Functions";
import Uploader from "../ui/Uploader";
import moment from "moment";
import certificationService from "../../services/certification.service";
import SelectAjax from "../ui/SelectAjax";
import billingService from "../../services/billing.service";
import BillingModal from "./Shared/BillingModal";
import BillMultiple from "./Shared/BillMultiple";
import { EditableCell } from "../EditableCell";
import { useSanctum } from "react-sanctum";
import { formatLocalDate } from "../Modification/Helpers/time";
import { usePermissions } from "../../hooks/usePermissions";
let hideMessage = null;
const { RangePicker } = DatePicker;

const Certification = () => {
  let { slug } = useParams();
  const [selectedRange, setSelectedRange] = useState(null);
  const [currentId, setCurrentId] = useState(null);
  const [certUploadId, setCertUpload] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [form] = Form.useForm();
  const [selectedRows, setSelectedRows] = useState([]);
  const [isBilling, setIsBilling] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalMultipleVisible, setIsModalMultipleVisible] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { user } = useSanctum();

  const certificationUrl = `/certifications?certcategory=${slug ?? ""}`;

  let setFilter = () => {};

  const showDrawer = (id) => {
    setCertUpload(id);
    setVisible(true);
  };
  const onCloseDrawer = () => {
    setCertUpload(null);
    setVisible(false);
  };

  const handleUpdate = async (record, price) => {
    message.loading({ duration: 0.5, content: "Cargando" });
    await certificationService.update(record.id, { price });

    reload();
  };

  const toggleLoadingRecord = (status) => {
    if (status) {
      hideMessage = message.loading("Descargando...", 0);
    } else if (hideMessage) {
      hideMessage();
      hideMessage = null;
    }
  };

  const viewInvoice = async (record) => {
    toggleLoadingRecord(true);
    const url = await getInvoiceToBlobUrl(record.id);
    showPdfInModal(url);
    toggleLoadingRecord(false);
  };

  // const viewInvoiceTicket = async (record) => {
  //   toggleLoadingRecord(true);
  //   const url = await getTicketToBlobUrl(
  //     record?.billings?.[0]?.external_invoice_id,
  //   );
  //   print(url);
  //   toggleLoadingRecord(false);
  // };
  const viewInvoiceTicket = async (record) => {
    const activeBilling = record?.billings?.find(
      (billing) => billing.status !== "cancelled",
    );

    if (!activeBilling?.external_invoice_id) {
      message.warning("Esta certificación no tiene una factura activa.");
      return;
    }

    toggleLoadingRecord(true);
    try {
      const url = await getTicketToBlobUrl(activeBilling.external_invoice_id);
      print(url);
    } finally {
      toggleLoadingRecord(false);
    }
  };
  const columns = [
    {
      title: "Informe",
      dataIndex: "inspection_number",
      key: "inspection_number",
      sorter: true,
    },
    {
      title: "Placa",
      dataIndex: "plate",
      key: "plate",
      sorter: true,
    },
    {
      title: "Certificado",
      dataIndex: "certificate_number",
      key: "certificate_number",
      sorter: true,
      render: (value) => value ?? "-",
    },
    {
      title: "Propietario",
      dataIndex: "owner1",
      key: "owner1",
      render: (value, record) => (
        <Link to={"/certifications/" + record.id + "/edit"}>{value}</Link>
      ),
    },

    {
      title: "Fecha",
      dataIndex: "date",
      key: "date",
      render: (value) => (value ? formatLocalDate(moment(value)) : "-"),
    },

    {
      title: "Precio",
      dataIndex: "price",
      key: "price",
      render: (value, record) => (
        <EditableCell
          value={value}
          onSave={(newPrice) => handleUpdate(record, newPrice)}
        />
      ),
      align: "right",
      hidden: !user.roles.find(
        (a) => a.name === "superadmin" || a.name === "admin",
      ),
    },

    {
      title: "Cat",
      dataIndex: "class",
      key: "class",
      render: (value) => (value !== "" ? value : "-"),
    },

    {
      title: "Tipo",
      dataIndex: "certification_type_id",
      key: "certification_type_id",
      render: (value, record) => record.certification.name,
    },

    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      render: (value, record) => {
        return value === "finished" ? "Finalizado" : "En proceso";
      },
    },

    {
      title: "Facturado",
      dataIndex: "is_billed",
      key: "is_billed",
      align: "right",
      hidden: !user.roles.find(
        (a) => a.name === "superadmin" || a.name === "admin",
      ),
      render: (_, record) => {
        const activeBilling = record?.billings?.find(
          (billing) => billing.status !== "cancelled",
        );

        return activeBilling ? (
          <Button
            loading={record.isLoading}
            type="link"
            style={{ padding: 0 }}
            onClick={() => viewInvoiceTicket(record)}
          >
            <Tag color="green">{activeBilling.invoice_number}</Tag>
          </Button>
        ) : (
          <Tag color="red">NO</Tag>
        );
      },
    },

    {
      title: "Cert",
      dataIndex: "pdf_path",
      key: "pdf_path",
      render: (value, record) =>
        record.attachments.length > 0 ? (
          <a
            target={"blank"}
            style={{ color: "red" }}
            href={record.attachments[0].url}
          >
            <FilePdfOutlined />
          </a>
        ) : (
          "-"
        ),
    },

    {
      title: "PDF",
      dataIndex: "pdf_path",
      key: "pdf_path",
      width: 55,
      render: (pdf_path, record) => {
        return (
          <div>
            {pdf_path ? (
              <a onClick={() => downloadPDF(true, record.id, record.pdf_url)}>
                <FilePdfOutlined />
              </a>
            ) : (
              "-"
            )}

            {record.pdf_path_extra ? (
              <a
                onClick={() =>
                  downloadPDF(true, record.id, `${record.pdf_url}?extra=true`)
                }
              >
                <FilePdfOutlined style={{ color: "#ff4d4f", marginLeft: 8 }} />
              </a>
            ) : null}
          </div>
        );
      },
    },

    {
      title: "Documentos",
      dataIndex: "id",
      key: "documents",
      render: (value) => (
        <Button onClick={() => showDrawer(value)} size="small">
          Ver o subir
        </Button>
      ),
    },

    {
      title: "Editar",
      dataIndex: "id",
      width: 90,
      key: "edit",
      render: (id) => (
        <Link to={"/certifications/" + id + "/edit"}>
          <EditOutlined /> Editar
        </Link>
      ),
    },
  ].filter((a) => a.hidden !== true);

  useEffect(() => {
    document.title = "Listado de certificaciones";
  }, []);

  const exportExcelNuevo = async (filters) => {
    const filterMerged = { certcategory: slug, ...filters };
    try {
      const data = await certificationService.exportExcelNuevo(filterMerged);

      downloadFromData(data, "application/vnd.ms-excel", "certifications.xlsx");
    } catch (error) {
      message.error(error.message);
    }
  };

  const rowSelection = {
    onChange: (_, selectedRows) => {
      setSelectedRows(selectedRows);
    },
    getCheckboxProps: (record) => ({
      id: record.id,
      name: record.name,
      disabled: record.is_billed === 1,
    }),
  };

  const handleBillMultiple = async (data) => {
    const { payment_method, notes, voucher, phone } = data;

    const payment_condition = "cash";

    setIsBilling(true);
    try {
      await billingService.billMultiple({
        rows: selectedRows,
        payment_method,
        notes,
        payment_condition,
        voucher,
        phone,
      });
      message.success("Factura múltiple generada con éxito");
      setIsModalMultipleVisible(false);
      setSelectedRows([]);

      reload();
    } catch (error) {
      if (error.response?.status === 403) {
        message.warning("No estás autorizado para emitir facturación múltiple");
      } else {
        message.error(error.message || "Error al generar las facturas");
      }
    } finally {
      setIsBilling(false);
    }
  };

  const handleMassiveDelete = () => {
    Modal.confirm({
      title: "Confirmar anulación masiva",
      icon: <ExclamationCircleOutlined />,
      content: `Se anularán ${selectedRows.length} registros y sus registros relacionados. ¿Estás seguro?`,
      okText: "SI",
      cancelText: "NO",
      onOk: async () => {
        setIsDeleting(true);
        let successCount = 0;
        let failCount = 0;
        for (const row of selectedRows) {
          try {
            const res = await certificationService.remove(row.id);
            if (res.success) {
              successCount++;
            } else {
              failCount++;
            }
          } catch (error) {
            failCount++;
          }
        }
        setIsDeleting(false);

        if (failCount > 0) {
          message.warning(`Se anularon ${successCount} registros, pero fallaron ${failCount}.`);
        } else {
          message.success(`Se anularon ${successCount} registros exitosamente.`);
        }
        
        setSelectedRows([]);
        reload();
      },
    });
  };

  const showBillSingleModal = () => {
    form.resetFields();
    setIsModalVisible(true);
  };

  const reload = () => {
    setFilter({ nc: Math.random() * 100 });
  };

  const handleBillSingle = async (data) => {
    try {
      const {
        description,
        type,
        document_number,
        customer_name,
        document_type,
        payment_condition,
        payment_method,
        purchase_order,
        notes,
        voucher,
        phone,
      } = data;
      setIsModalVisible(false);
      setIsBilling(true);

      await billingService.billSingle({
        items: selectedRows,
        description,
        type,
        document_number,
        customer_name,
        document_type,
        payment_condition,
        payment_method,
        purchase_order,
        notes,
        voucher,
        phone,
      });

      message.success("Factura única generada con éxito");

      reload();

      form.resetFields();
    } catch (error) {
      if (error.response?.status === 403) {
        message.warning("No estás autorizado para emitir facturación única");
      } else if (error.name !== "ValidationError") {
        message.error(error.message || "Error al generar la factura");
      }
    } finally {
      setIsBilling(false);
    }
  };

  const descriptionDefault = `Por certificación de ${selectedRows.length} placas`;

  const { hasBillingAccess } = usePermissions();

  return (
    <div className="container">
      <CustomTable
        rowSelection={rowSelection}
        edit={currentId}
        title="Certificaciones"
        columns={columns}
        onCancel={() => setCurrentId(null)}
        url={certificationUrl}
      >
        {({ filters, filterText, applyFilter, resetFilters }) => {
          setFilter = applyFilter;
          return (
            <div className="flex">
              {selectedRows.length > 0 && hasBillingAccess === true && (
                <>
                  <Button
                    loading={isBilling}
                    onClick={() => setIsModalMultipleVisible(true)}
                    icon={<OrderedListOutlined />}
                    type="primary"
                    ghost
                  >
                    Facturar varios
                  </Button>
                  <Button
                    loading={isBilling}
                    onClick={showBillSingleModal}
                    icon={<FileOutlined />}
                    type="primary"
                    ghost
                  >
                    Factura única
                  </Button>
                  <Button
                    loading={isDeleting}
                    onClick={handleMassiveDelete}
                    icon={<DeleteOutlined />}
                    danger
                  >
                    Anular masivo
                  </Button>
                </>
              )}

              <Button
                icon={<FilterOutlined />}
                onClick={() => {
                  setFilterVisible(true);
                }}
              >
                Filtros
              </Button>

              <Drawer
                visible={filterVisible}
                onClose={() => setFilterVisible(false)}
                title="Filtrar certificaciones"
                width={350} // Ajuste de ancho
              >
                <Form layout="vertical" form={form}>
                  <Form.Item name="company_id" label="Empresa">
                    <SelectAjax
                      onSelect={(value) => {
                        applyFilter({ company_id: value });
                      }}
                      size="middle"
                      showSearch
                      optionFilterProp="children"
                      url={"/companies-list"}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item name="garage_id" label="Taller">
                    <SelectAjax
                      onSelect={(value) => {
                        applyFilter({ garage_id: value });
                      }}
                      size="middle"
                      showSearch
                      optionFilterProp="children"
                      url={"/garages-list"}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item name="customer_id" label="Cliente">
                    <SelectAjax
                      onSelect={(value) => {
                        applyFilter({ customer_id: value });
                      }}
                      size="middle"
                      showSearch
                      optionFilterProp="children"
                      url={"/customers-list"}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="certification_type_id"
                    label="Tipo de certificación"
                  >
                    <SelectAjax
                      onSelect={(value) => {
                        applyFilter({ certification_type_id: value });
                      }}
                      size="middle"
                      url={"/certification-types"}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item name={"range"} label="Rango de fechas">
                    <RangePicker
                      value={selectedRange}
                      ranges={{
                        Hoy: [moment(), moment()],
                        Ayer: [
                          moment().add(-1, "days").startOf("day"),
                          moment().add(-1, "days").endOf("day"),
                        ],
                        "Este mes": [
                          moment().startOf("month"),
                          moment().endOf("month"),
                        ],
                        "El mes pasado": [
                          moment().add(-1, "months").startOf("month"),
                          moment().add(-1, "months").endOf("month"),
                        ],

                        "Este año": [
                          moment().add(-1, "months").startOf("month"),
                          moment().add(-1, "months").endOf("month"),
                        ],
                        "El año pasado": [
                          moment().add(-1, "years").startOf("year"),
                          moment().add(-1, "years").endOf("year"),
                        ],
                      }}
                      onChange={(values) => {
                        if (values) {
                          setSelectedRange(values);
                          applyFilter({
                            from: values[0].format("YYYY-MM-DD"),
                            to: values[1].format("YYYY-MM-DD"),
                          });
                        }
                      }}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      onClick={() => {
                        resetFilters();
                        setTimeout(() => {
                          form.resetFields();
                        }, 100);

                        setSelectedRange(null);
                      }}
                      icon={<ReloadOutlined />}
                      block
                    >
                      Resetear filtros
                    </Button>
                  </Form.Item>
                </Form>
              </Drawer>

              <Button
                type="primary"
                ghost
                style={{ marginRight: 5 }}
                onClick={() => exportExcelNuevo({ ...filters, filterText })}
              >
                Exportar
              </Button>
              {slug && (
                <Button type="primary">
                  <Link to={"/certifications/" + slug + "/new"}>
                    + Nuevo ingreso{" "}
                  </Link>
                </Button>
              )}
            </div>
          );
        }}
      </CustomTable>

      <BillingModal
        rows={selectedRows}
        open={isModalVisible}
        onOk={handleBillSingle}
        onCancel={() => setIsModalVisible(false)}
        confirmLoading={isBilling}
        descriptionDefault={descriptionDefault}
      />

      <BillMultiple
        rows={selectedRows}
        open={isModalMultipleVisible}
        onOk={handleBillMultiple}
        onCancel={() => setIsModalMultipleVisible(false)}
        confirmLoading={isBilling}
        descriptionDefault={descriptionDefault}
      />

      <Drawer
        title="Documentos"
        width={400}
        placement="right"
        onClose={onCloseDrawer}
        open={visible}
      >
        <Divider>Certificado</Divider>
        <div className="uploader">
          <Uploader type={"certificate"} certificationId={certUploadId} />
        </div>

        <Divider>Documentos</Divider>
        <div className="uploader">
          <Uploader type={"document"} certificationId={certUploadId} />
        </div>
        <Divider>Fotos</Divider>
        <div className="uploader">
          <Uploader type={"photo"} certificationId={certUploadId} />
        </div>
      </Drawer>
    </div>
  );
};

export default Certification;
